import { useTranslation } from 'react-i18next';
import { ReactSVG } from 'react-svg';
import { fDate } from '@web/utils/src';
import downloadIcon from '@web/utils/src/assets/icons/functions/download-icon.svg';
import pdfIcon from '@web/utils/src/assets/icons/functions/pdf-icon.svg';
import { ContractAttachment } from '@/types';

type Props = {
  attachment: ContractAttachment;
  contractId: string;
};

const Attachment: React.FC<Props> = ({ attachment, contractId }) => {
  const { t } = useTranslation();

  const HandleDocumentDownload = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <div
      key={attachment.key}
      className="p-1-6 rounded-8-0 border border-secondary-grey my-2-0 w-44-0 flex items-center justify-between  cursor-pointer"
      onClick={() => HandleDocumentDownload(attachment.signedUrl)}
    >
      <div className="flex">
        <ReactSVG src={pdfIcon} className="mr-2-0" />
        <div className="items-center mb-1-6">
          <div>
            <span className="font-bd text-1-6">{t('contracts.contract')}</span>
            <span className="text-1-6">{fDate(attachment.createdAt)}</span>
          </div>
          <div className="md:text-1-3 text-1-6 mt-2-0">
            <p>{contractId}</p>
          </div>
        </div>
      </div>
      <ReactSVG src={downloadIcon} className="download-icon text-white" />
    </div>
  );
};

export default Attachment;
